import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndPointsService } from '../constants/end-points/end-points.service';
import { BaseResponse } from '../models/base-response';
import { DrugSearchCriteria } from '../models/drug-search-criteria';
import { Observable, Subject } from 'rxjs';
import { ValidMatchingEntry } from '../models/valid-matching-entry';
import { PlanDetails } from '../models/plan-details';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DrugSearchURLService {

  planDetails : PlanDetails;
  messageKeyValueMap = new Map();

  private globalSubject = new Subject<any>();
	  
  setGlobalSubject(val) {
  this.globalSubject.next(val);
  }

  getGlobalSubject(): Observable<any> {
  return this.globalSubject.asObservable();
  }

  constructor( private _http: HttpClient,private _endPointsService: EndPointsService) { }

  getMessages(): Observable<BaseResponse> {
    return this._http.get<BaseResponse>(this._endPointsService.getMessages());
  }

  getPlanDetails(randomUUID: string) {
    return this._http.get<BaseResponse>(this._endPointsService.getPlanDetails(randomUUID));
  }

  getTCCCategoryDetails(packageId: number) {
    return this._http.get<BaseResponse>(this._endPointsService.getTCCCategoryDetails(packageId));
  }

  getTCCClassDetails(groupId:number, category: string) {
    return this._http.get<BaseResponse>(this._endPointsService.getTCCClassDetails(groupId,category));
  }

  searchByTCCClass(drugSearchCriteria: DrugSearchCriteria) {
    return this._http.post<BaseResponse>(this._endPointsService.searchByTCCClass(), drugSearchCriteria);
  }

  searchByDrugName(value: string) {
    return this._http.get<BaseResponse>(this._endPointsService.searchByDrugName(value));
  }

  fetchPDFReport(planId: number, reportType: string) {
    window.open(this._endPointsService.fetchPDFReport(planId, reportType));
  }

  fetchExternalPDFReport(planId: number, externalPDF: string) {
    window.open(this._endPointsService.fetchExternalPDFReport(planId, externalPDF));
  }

  getCoverageDetails(drugSearchCriteria: DrugSearchCriteria): Observable<any> {
    return this._http.post<BaseResponse>(this._endPointsService.getCoverageDetails(),drugSearchCriteria);
  }

  getNonFormularyDrugDetails(drugSearchCriteria: DrugSearchCriteria): Observable<any> {
    return this._http.post<BaseResponse>(this._endPointsService.getNonFormularyDrugDetails(),drugSearchCriteria);
  }

  getDrugSearchDetailData(drugSearchMatchingEntry : ValidMatchingEntry[]): Observable<any> {
    return this._http.post<BaseResponse>(this._endPointsService.getDrugSearchDetailData(),drugSearchMatchingEntry);
  }

  getAlternatives(drugSearchCriteria: DrugSearchCriteria): Observable<any> {
    return this._http.post<BaseResponse>(this._endPointsService.getAlternatives(),drugSearchCriteria);
  }
  searchDrugs(value: string) {
    return this._http.get<BaseResponse>(this._endPointsService.searchDrugs(value)).pipe(map(res => res.data));
  }


}
